import { getLocale } from "../helpers/locale";

export default defineI18nConfig(() => ({
  legacy: false,
  locale: getLocale(),
  warnHtmlMessage: false
}));